<template>
  <div>
    <div class="header clearfix" :class="{ active: !logoShow }">
      <div class="logo fl">
        <a href="javascript:;" class="fl" v-show="logoShow">
          <img src="../../assets/img/logo.png" alt=""/>
        </a>
        <a href="javascript:;" class="fl" v-show="!logoShow">
          <img src="../../assets/img/logo_t.png" alt=""/>
        </a>
      </div>
      <div class="logoImg" @click="showMenu">
        <img src="../../assets/img/sy_cd_jt_zk.png" alt="" v-show="logoShow"/>
        <img
          src="../../assets/img/sy_cd_jt_zk2.png"
          alt=""
          v-show="!logoShow"
        />
      </div>
      <div
        class="selectWrap fl"
        @mouseenter="showList(true)"
        @mouseleave="showList(false)"
      >
        <div class="school" @click="showInput">
          <i></i>
          <input class="showInput" ref="input" v-if="search" @blur="search=false" @input="searchSchool"
                 v-model="searchName"></input>
          <template v-else>
            <span class="schoolName">{{ teacher.kinderGartenName }}</span>
            <span v-if="kinderAttribute == 1" class="main">主园</span>
            <span v-if="kinderAttribute == 2" class="branch">分园</span>
          </template>
        </div>
        <div
          class="schoolList"
          v-if="isShowList && schoolList.length > 0"
        >
          <div class="list">
            <ul>
              <li v-for="item in schoolList" :key="item.schoolId">
                <a
                  href=""
                  @click.prevent="selectSchool(item)"
                  :class="
                    teacher.kinderGartenId == item.schoolId ? 'active' : ''
                  "
                >{{ item.schoolName }}
                  <span
                    v-if="
                      item.schoolAttribute == 1 || item.schoolAttribute == 2
                    "
                    :class="item.schoolAttribute == 2 ? 'active' : ''"
                  >{{
                      item.schoolAttribute == 1
                        ? "主园"
                        : item.schoolAttribute == 2
                          ? "分园"
                          : ""
                    }}</span
                  ></a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="term fl">
        <el-select
          v-model="termId"
          placeholder="请选择"
          @change="changeSemester"
          style="width: 290px"
          :disabled="termText == 0 ? true : false"
        >
          <el-option
            v-for="item in semesterList"
            :label="
              item.schoolYear +
              '学年：' +
              item.startDate +
              ' 至 ' +
              item.endDate
            "
            :value="item.schoolYear"
            :key="item.schoolYear"
          ></el-option>
        </el-select>
      </div>

      <!-- <div class="settings fr" @mouseenter="enterBtn()" @mouseleave="leaveBtn()">
      <a href="javascript:;" class="btn-settings">设置</a>

      <Settings v-show="isShow" @visible="visible"></Settings>
    </div> -->

      <div class="user fr" @mouseenter="enter()" @mouseleave="leave()">
        <div class="userInfo">
          <a href="javascript:;" class="avatar">
            <span class="count" v-if="allCount > 0">{{ allCount }}</span>
            <img :src="teacher.head" alt/>
          </a>
          <i
            v-if="ssoApp.length"
            class="userName el-icon-arrow-down el-icon--right"
          ></i>
          <span class="userName" v-else>
            你好，{{ teacher.name }}老师({{ teacher.kinderGartenName }})
          </span>
        </div>

        <Dropdown
          v-show="isDropdwon"
          :xxCount="xxCount"
          :bjCount="bjCount"
          :teacher="teacher"
        ></Dropdown>
      </div>
      <div class="Third fr btns">
        <router-link to="/classHome">
          <img class="img1" src="../../assets/img/tb_bjq.png" alt="">
        </router-link>
        <router-link to="/ai/index" v-if="false">
          <img class="img2" src="../../assets/img/tb_znzs.png" alt="">
        </router-link>
      </div>
      <div class="Third fr" v-if="ssoApp.length">
        <el-popover
          placement="bottom"
          trigger="hover">
          <template slot="reference">
            <a href="" @click.prevent="" class="thirdTit">
              <i class="icon-pt"></i>合作平台
              <i class="el-icon-arrow-down el-icon--right"></i>
            </a>
          </template>

          <div class="ThirdDrop">
            <div class="topTit">
              <img src="../../assets/img/hzpt_xtb_pt.png" alt=""/>
              <span>第三方合作平台</span>
            </div>
            <div class="threeLogo">
              <a @click.prevent="openPlatform(item)" href="javascript:void(0)" v-for="item in ssoApp" :key="item.appId">
                <img v-if="item.name=='云管家'" src="../../assets/images/sy_ptrk_ygj.png" alt=""/>
                <img v-if="item.name=='云慧玩'" src="../../assets/images/sy_ptrk_yhw.png" alt=""/>
                <div v-if="isDazhiNurseryApp(item)" class="nursery-platform-card">
                  <span class="nursery-platform-icon">托</span>
                  <span class="nursery-platform-copy">
                    <strong>大知托幼</strong>
                    <small>{{ nurseryLoading ? "正在安全登录..." : "智慧托育学校端" }}</small>
                  </span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </a>
            </div>
          </div>
        </el-popover>
      </div>

      <Version :dialogVisible="dialogVisible" @close="close"></Version>
    </div>
    <breadcrumb class="breadcrumb-container" :class="{ active: !logoShow }"/>
  </div>
</template>


<script>
import qs from "qs";
import Dropdown from "./TeacherDropdown";
import Settings from "./SettingsDropdown";
import Version from "./Version";
import Breadcrumb from "../Breadcrumb/index";
import Signal from "../../assets/js/signal.js";

export default {
  name: "head1",
  components: {Dropdown, Settings, Version, Breadcrumb},
  data() {
    let ssoApp = localStorage.getItem("SsoApp")
    return {
      searchName: '',
      search: false,
      dialogVisible: false,
      isShow: false,
      isDropdwon: false,
      xxCount: 0,
      bjCount: 0,
      teacher: {},
      isShowList: false,
      logoShow: true,
      kinderAttribute: 0,

      ThirdUrl: "",
      ThirdData: [],

      termId: 0,
      semesterList: [],
      termText: "",
      schoolList: [],
      ssoApp: ssoApp ? JSON.parse(localStorage.getItem("SsoApp")) : [],
      nurseryLoading: false,
    };
  },
  computed: {
    allCount: function () {
      return this.xxCount + this.bjCount;
    },
  },
  mounted() {
    this.getTeacherInfo();
    this.getSemester();
    this.termText = JSON.parse(localStorage.getItem("userInfo")).isSetSemester;

    if (this.ssoApp.length == 0) {
      this.getSsoApp();
    }
    var loginType = localStorage.getItem("loginType");
    if (loginType != 3) this.$router.push("/homepage");
  },
  methods: {
    showInput() {
      this.searchName = ''
      this.search = true;
      this.schoolList = this.teacher.schoolList;
      this.$nextTick(() => {
        this.$refs.input.focus();
      })
    },
    searchSchool() {
      if (this.searchName == '') {
        this.schoolList = this.teacher.schoolList;
      } else {
        this.schoolList = this.teacher.schoolList.filter(item => {
          return item.schoolName.indexOf(this.searchName) > -1;
        })
      }
    },
    visible() {
      this.dialogVisible = true;
    },
    version() {
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
    //用户
    enter() {
      this.isDropdwon = true;
    },
    leave() {
      this.isDropdwon = false;
    },
    //设置
    enterBtn() {
      this.isShow = true;
    },
    leaveBtn() {
      this.isShow = false;
    },
    getTeacherInfo() {
      var userInfo = null; //localStorage.getItem("userInfo");
      if (userInfo == undefined || userInfo == null || userInfo == {}) {
        this.axios
          .post("api/user/GetTeacherInfo")
          .then((res) => {
            if (res.data.resultType == 0) {
              this.teacher = res.data.appendData.teacher;
              // console.log(res.data);
              this.teacher.schoolList.forEach((item) => {
                if (item.schoolId == this.teacher.kinderGartenId) {
                  this.kinderAttribute = item.schoolAttribute;
                }
              });
              this.schoolList = this.teacher.schoolList;
              if (this.teacher.kinderGartenId == 0) {
                this.$router.push("/homepage");
              }
              this.xxCount = res.data.appendData.notice.noticeCount;
              this.bjCount = res.data.appendData.notice.classNoticeCount;

              //重置默认人群
              // this.$common.resetCriwd();
            } else if (res.data.resultType == 401) {
              localStorage.clear();
              // this.$router.push("/login");
            } else {
              this.$alert(res.data.message);
            }
          })
          .catch((err) => {
            this.$alert(err);
          });
      } else {
        this.teacher = JSON.parse(userInfo);
      }
    },

    showList(isShow) {
      if (!this.search) {
        this.schoolList = this.teacher.schoolList;
      }
      this.isShowList = isShow;
    },

    selectSchool(item) {
      this.isShowList = false;
      if (this.teacher.kinderGartenId != item.schoolId) {
        this.$confirm("确认要切换到<" + item.schoolName + ">吗?", "提示", {
          type: "warning",
        })
          .then(() => {
            this.axios
              .post(
                "api/user/schoollogin",
                qs.stringify({schoolId: item.schoolId})
              )
              .then((res) => {
                // console.log("schoollogin:then");
                let data = res.data;
                if (data.resultType == 0) {
                  var jwt = data.appendData.jwt;
                  localStorage.setItem("loginToken", "Bearer " + jwt.token);
                  localStorage.setItem("tokenExpires", jwt.expiresLong);

                  // console.log(data.appendData.user);
                  var user = data.appendData.user;
                  localStorage.setItem("userInfo", user);
                  this.$store.commit("setUser", user);
                  localStorage.removeItem("placeData");
                  localStorage.removeItem("classData");
                  if (user.kinderGartenId == 0) {
                    this.$router.push("/homepage");
                  } else {
                    this.$router.push("/");
                  }

                  this.$message.success(data.message);
                  this.getSsoApp();
                } else {
                  this.$alert(data.message);
                }
              })
              .catch((err) => {
                this.$alert(err);
              });
          })
          .catch(() => {
          });
      }
    },
    getSsoApp() {
      this.axios
        .post("api/YYT3PC/Home/GetSsoApp2")
        .then((res) => {
          if (res.data.resultType == 0) {
            this.ssoApp = res.data.appendData;
            localStorage.setItem("SsoApp", JSON.stringify(res.data.appendData));
            this.loginSuccess();
            // location.reload();
          }
        })
        .catch((err) => this.$alert(err));
    },
    loginSuccess() {
      localStorage.removeItem("classData");
      localStorage.removeItem("schoolDevice");
      localStorage.removeItem("crowds");
      if (this.loginType != 3) {
        if (this.sjfxJump == "_self") {
          this.axios
            .post("api/user/GetAdminInfo")
            .then((res) => {
              if (res.data.resultType == 0) {
                this.admin = res.data.appendData;
                localStorage.setItem("userInfo", this.admin);

                localStorage.setItem("admindid", this.admin.districtId);
                localStorage.setItem("admindname", this.admin.cityName);
                this.$store.commit("setUser", this.admin);
                this.$router.push("/homepage");
              } else if (res.data.resultType == 401) {
                this.$alert(res.data.message);
                localStorage.clear();
                this.$router.push("/login");
              }
            })
            .catch((err) => {
              this.$alert(err);
            });
        } else if (this.sjfxJump == "_blank") {
          location.href = this.sjfxPage + url;
        }
      } else {
        let redirect = this.$route.query.redirect;
        if (redirect) {
          if (redirect == "/homepage") this.$router.push("/datas");
          else this.$router.push(redirect);
        } else {
          this.$router.push("/home");
        }
      }
    },
    showMenu() {
      this.logoShow = !this.logoShow;
      Signal.$emit("logoMenu", this.logoShow);
    },

    getAppUrl(appid) {
      this.axios
        .post(
          "api/YYT3PC/Home/GetUrl",
          qs.stringify({
            appid,
          })
        )
        .then((res) => {
          if (res.data.resultType == 0) {
            window.open(res.data.message, "_blank");
          }
        })
        .catch((err) => this.$alert(err));
    },

    isDazhiNurseryApp(item) {
      return item && (item.types == 20 || item.name == "大知托幼");
    },

    openPlatform(item) {
      if (this.isDazhiNurseryApp(item)) {
        this.getDazhiNurseryEntryUrl(item.appId);
        return;
      }
      this.getAppUrl(item.appId);
    },

    getDazhiNurseryEntryUrl(appid) {
      if (this.nurseryLoading) return;

      this.nurseryLoading = true;
      const targetWindow = window.open("about:blank", "_blank");
      this.axios
        .post(
          "api/YYT3PC/Home/GetDazhiNurseryEntryUrl",
          qs.stringify({
            appid,
            redirect: "careOverview",
          })
        )
        .then((res) => {
          if (res.data.resultType == 0 && res.data.appendData) {
            if (targetWindow) {
              targetWindow.location.replace(res.data.appendData);
            } else {
              window.location.href = res.data.appendData;
            }
          } else {
            if (targetWindow) targetWindow.close();
            this.$message.error(res.data.message || "进入大知托幼失败");
          }
        })
        .catch((err) => {
          if (targetWindow) targetWindow.close();
          this.$alert(err);
        })
        .finally(() => {
          this.nurseryLoading = false;
        });
    },

    getSemester() {
      this.axios
        .post("api/User/GetSchoolYear")
        .then((res) => {
          if (res.data.resultType == 0) {
            let data = res.data.appendData;
            this.semesterList = data;
            sessionStorage.setItem("semesterList", JSON.stringify(data));
            if (data.length > 0) {
              let arr = data.filter((item) => item.selected == true);
              // console.log("head", arr);
              if (arr.length != 0) {
                data.forEach((item, index) => {
                  if (item.selected) {
                    this.termId = item.schoolYear;
                  }
                });
              } else {
                // this.visibleSemester = true;
                this.termId = data[data.length - 1].schoolYear;
              }
            }
          } else {
          }
        })
        .catch((err) => this.$alert(err));
    },
    changeSemester(val) {
      // this.termId = val;
      this.getSemesterInfo();
    },
    getSemesterInfo() {
      this.axios
        .post(
          "api/User/SetSchoolYear",
          qs.stringify({schoolYear: this.termId})
        )
        .then((res) => {
          if (res.data.resultType == 0) {
            localStorage.removeItem("classData");
            this.$router.go(0)
            // location.reload()
            this.$message.success(res.data.message);
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => this.$alert(err));
    },
  },
};
</script>

<style scoped lang="less">
.header {
  height: 72px;
  padding: 0 25px;
  background: #3fbe3c;
  position: relative;
  z-index: 9;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1);
  position: relative;

  .logoImg {
    width: 28px;
    height: 28px;
    position: absolute;
    top: 46%;
    transform: translateY(-50%);
    left: 246px;
  }

  .logo {
    width: 260px;
    padding: 14px 0;
    background-color: #1fbb1d;

    img {
      width: 143px;
      height: 39px;
    }
  }

  .user {
    padding: 12px 0 12px 0;
    //margin-right: 38px;
    position: relative;

    .userInfo {
      cursor: pointer;
    }

    .avatar {
      display: inline-block;
      vertical-align: middle;
      position: relative;

      .count {
        display: inline-block;
        min-width: 16px;
        height: 16px;
        border-radius: 10px;
        padding: 0 5px;
        background: #ff0e0e;
        color: #fff;
        font-size: 12px;
        text-align: center;
        line-height: 15px;
        position: absolute;
        right: -10px;
        top: -4px;
        border: 1px solid #fff;
      }

      img {
        width: 44px;
        height: 44px;
        border-radius: 50%;
      }
    }

    .userName {
      vertical-align: middle;
      font-size: 15px;
      // color: #505f75;
      color: #fff;
      margin-left: 5px;
    }
  }

  .selectWrap {
    padding: 14px 0;
    cursor: pointer;
    position: relative;
    left: 18px;

    .school {
      display: inline-block;
      margin: 6px 0;
      padding: 0 10px;
      height: 28px;
      background: #0daa0b;
      border-radius: 30px;

      .showInput {
        background: transparent;
        width: 150px;
        color: #fff;
      }

      i {
        display: inline-block;
        width: 15px;
        height: 15px;
        background: url("../../assets/img/ty_xtb_school.png");
        background-size: 100% 100%;
        margin-right: 6px;
      }

      i,
      .schoolName {
        vertical-align: middle;
        font-size: 15px;
        color: #fff;
        line-height: 28px;
        margin-right: 5px;
      }

      .main,
      .branch {
        width: 40px;
        height: 19px;
        font-size: 12px;
        line-height: 19px;
        display: inline-block;
        padding-left: 6px;
      }

      .main {
        background: url("../../assets/img/stbq_1.png") no-repeat;
        background-size: 36px 19px;
        color: #fff;
      }

      .branch {
        background: url("../../assets/img/stbq_2.png") no-repeat;
        background-size: 39px 19px;
        color: #fff;
      }
    }

    .schoolList {
      // position: relative;
      padding-top: 14px;
      width: 270px;
      // left: -10px;
      position: absolute;
      top: 50px;

      // left: 50%;
      // transform: translate(-50%);
      &:before {
        content: "";
        width: 100%;
        height: 8px;
        background: url(../../assets/images/img_sj.png) no-repeat;
        background-size: 15px 8px;
        background-position: center 0;
        position: absolute;
        top: 6px;
        // left: 0;
        left: -50%;
        transform: translate(6%);
      }

      .list {
        max-height: 350px;
        overflow: auto;
        background: #fff;
        box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);
        border-radius: 10px;

        ul {
          li {
            + li {
              border-top: 1px solid #f2f2f2;
            }

            a {
              display: block;
              font-size: 15px;
              color: #1c1c1c;
              padding: 14px 10px 14px 40px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              &:hover {
                color: #2cb11d;
              }

              &.active {
                background: url("../../assets/images/img_select2.png") no-repeat;
                background-size: 15px 11px;
                background-position: 15px center;
              }
            }

            span {
              border: 1px solid #fda843;
              font-size: 12px;
              color: #fda843;
              padding: 2px 5px;

              &.active {
                border: 1px solid #04a100;
                color: #04a100;
              }
            }
          }
        }
      }
    }
  }

  &.active {
    .logo {
      width: 70px;
      padding: 14px 0;
      background-color: #1fbb1d;

      img {
        width: 40px;
        height: 39px;
      }
    }

    .logoImg {
      width: 28px;
      height: 28px;
      position: absolute;
      top: 46%;
      transform: translateY(-50%);
      left: 106px;
    }

    .selectWrap {
      padding: 14px 0;
      cursor: pointer;
      position: relative;
      left: 56px;
    }
  }

  .term {
    padding: 20px 0;
    cursor: pointer;
    position: relative;
    left: 26px;

    /deep/ .el-select {
      .el-input__icon {
        line-height: 28px;
      }

      .el-input {
        .el-input__inner {
          border-radius: 50px;
          background: #0daa0b;
          color: #fff;
          height: 28px;
          border: none;
        }
      }
    }
  }

  .Third {
    height: 100%;
    line-height: 4;
    margin-right: 14px;
    cursor: default;

    .thirdTit {
      color: #fff;

      .icon-pt {
        width: 16px;
        height: 16px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
        background: url("../../assets/img/sy_cd_xtb_hzpt.png") no-repeat;
        background-size: 16px;
        // background-position: ;
      }
    }
  }

  .btns {
    display: flex;
    align-items: flex-end;
    padding-bottom: 18px;

    img {
      margin: 0 8px;
    }

    .img1 {
      width: 90px;
      height: 34px;
    }

    .img2 {
      width: 72px;
      height: 47px;
    }
  }
}

.ThirdDrop {
  .topTit {
    width: 220px;
    background: #e6ffe5;
    border-radius: 5px;
    padding: 4px 10px;
    box-sizing: border-box;

    img {
      width: 30px;
      height: 30px;
      display: inline-block;
      vertical-align: middle;
    }

    span {
      color: #04a100;
    }
  }

  .threeLogo {
    margin-top: 20px;

    img {
      width: 224px;
      height: 64px;
      display: block;
      vertical-align: middle;
      margin:5px 0;
    }

    a {
      color: #0460d2;
    }

    .nursery-platform-card {
      width: 224px;
      height: 64px;
      margin: 5px 0;
      padding: 10px 12px;
      box-sizing: border-box;
      border-radius: 8px;
      display: flex;
      align-items: center;
      color: #fff;
      background: linear-gradient(135deg, #20b486 0%, #208bd8 100%);
      box-shadow: 0 4px 12px rgba(32, 139, 216, 0.2);

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(32, 139, 216, 0.3);
      }

      .nursery-platform-icon {
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: 12px;
        text-align: center;
        font-size: 22px;
        font-weight: bold;
        background: rgba(255, 255, 255, 0.2);
      }

      .nursery-platform-copy {
        flex: 1;
        padding-left: 10px;

        strong,
        small {
          display: block;
        }

        strong {
          font-size: 17px;
          line-height: 24px;
        }

        small {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.85);
        }
      }
    }
  }
}

.breadcrumb-container {
  position: absolute;
  top: 73px;
  left: 276px;
  // z-index: 9;
  line-height: 40px;
  height: 40px;
  width: calc(100% - 286px);

  &.active {
    left: 84px;
    width: calc(100% - 94px);
  }
}

// .settings {
//   padding: 24px 0 24px 24px;
//   position: relative;
//   &:before {
//     content: "";
//     position: absolute;
//     width: 1px;
//     height: 18px;
//     background: #d6d8dd;
//     left: 0;
//     top: 50%;
//     transform: translateY(-50%);
//   }
// .btn-settings {
//   display: inline-block;
//   padding-left: 20px;
//   background: url("../../assets/images/img_settings.png") no-repeat;
//   background-size: 17px 15px;
//   background-position: 0 center;
//   font-size: 14px;
//   color: #505f75;
// }
// }
</style>



// WEBPACK FOOTER //
// src/components/Layout/Head.vue